import { useAuth0 } from "@auth0/auth0-react";
import { Checkbox } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { MyCheckbox } from "components";
import Action from "components/ActionPopOver";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import { findIndex } from "lodash";
import moment from "moment";
import React, { memo, useState } from "react";
import { toastr } from "react-redux-toastr";
import { DateFormetContext } from "../../../app/App.js";
import AlertDialog from "../../../components/Dialog";
import FinanceService from "../../../Lib/API/Finance/index";

const AccountSelectionTableData = (props) => {
  const {
    row,
    check,
    onPayNowClick,
    onReversalClick,
    setDrawerData,
    setOpenModal,
    onCheckboxChange,
    selectedData,
    onCheckboxClick,
    formik,
  } = props;
  const dateFormet = React.useContext(DateFormetContext);
  const [open, setOpen] = React.useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [reversalActionTypes, setReversalActionTypes] = useState(false);
  const [getTypes, setActionTypes] = useState("");
  const [paymentId, setPaymentId] = useState();
  const [chargeId, setchargeId] = useState();
  const fetchReversalTypes = async (type, Id1, Id2) => {
    setchargeId(Id1);
    setPaymentId(Id2);
    const token = await getAccessTokenSilently();
    await FinanceService.getAllReversalTypes(type, token).then((res) => {
      setActionTypes(res?.result);
    }).catch((err) => {
      toastr.error("Error", err?.data?.message);
    });

    setReversalActionTypes(true);
  };
  const handleCloseDialog = () => {
    setReversalActionTypes(false);
  };
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell padding="checkbox">
          <MyCheckbox
            handlechange={(e) => onCheckboxClick(e, row)}
            checked={
              findIndex(selectedData, (obj) => obj.id === row._id) !== -1
            }
          />
        </TableCell>
        <TableCell component="th" scope="row">
          <div className="sub title-name">
            {row?.name ?? row?.family_name?.toUpperCase()}
          </div>
        </TableCell>
        <TableCell align="left">
          <div className="sub">
            {numberFormat({number:row?.payment?.balance, decimal:2, style: 'currency'})}
          </div>
        </TableCell>

        <TableCell align="left">
          <div className="sub">{row?.payment?.billing_type?.title ?? "-"}</div>
        </TableCell>
        <TableCell align="left">
          <div className="table-row">
            <p className="sub">
              {
                row?.previosPymentDate === null
                  ? "-"
                  : row?.previosPymentDate
                    ? formatDate({date:row?.previosPymentDate, formatType: "defaultWithUTC"})
                    : "-"
              }
            </p>
          </div>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default memo(AccountSelectionTableData);
